import { useDispatch, useSelector } from "react-redux";
import { logoheader } from "../utils/images";
import { addUser, removerUser } from "../utils/userSlice";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../utils/firebase";
import { useEffect } from "react";
import { Link } from "react-router-dom";

import { addGptmovie, removeGptMovie, toggleShow } from "../utils/gptSlice";
import { Supported_language } from "../utils/languageIdentifies";
import { changeLang } from "../utils/languageSlice";

const Header = () => {
  const dispatch = useDispatch();
  const user = useSelector((store) => store.user);
  const gpt = useSelector((store) => store.gpt.showMainContainer);
  const navigate = useNavigate();
  const handleGPTclick = () => {
    dispatch(toggleShow());
    dispatch(removeGptMovie());
  };
  const handleSignOut = () => {
    signOut(auth)
      .then(() => {})
      .catch((error) => {
        // An error happened.
      });
  };
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        const { uid, email, displayName, photoURL } = user;
        dispatch(
          addUser({
            uid: uid,
            email: email,
            displayName: displayName,
            photoURL: photoURL,
          })
        );
        navigate("/browse");
      } else {
        // User is signed out
        dispatch(removerUser());
        const path = window.location.pathname;
        if (path !== "/login" && path !== "/") {
          navigate("/"); // Redirect to homepage (or login page)
        }
       
      }
    });
    return () => unsubscribe();
  }, [navigate,dispatch]);
  return (
    <div
      className={`flex justify-between w-screen md:px-14 fixed    ${
        !gpt && user && "md:relative lg:relative "
      }  bg-gradient-to-b from-black z-20 `}
    >
      <Link to={"/"}><div  className="h-16 text-red-700 text-5xl mt-2 shadow-2xl font-bold">NETGPT</div></Link>
      {user && (
        <div className="flex">
          <button
            onClick={handleGPTclick}
            className="text-white  mt-3  text-xl rounded-xl h-10 md:mt-4 w-auto px-2 md:text-xl hover:border"
          >
            {gpt ? "Home" : "🔍 AI Search"}
          </button>
          {!gpt ? (
            <h1 className="hidden md:block md:mt-6 ml-4 text-xl text-white">
              Hi, {user.displayName}
            </h1>
          ) : (
            <select
              className="h-10 mt-4 mx-2 rounded-lg px-2"
              onChange={(e) => dispatch(changeLang(e.target.value))}
            >
              {Supported_language.map((lang) => (
                <option
                  className="p-10"
                  key={lang.identifier}
                  value={lang.identifier}
                >
                  {lang.name}
                </option>
              ))}
            </select>
          )}
          <img
            className=" hidden md:block h-10 m-4 lg:block"
            src={user.photoURL}
          ></img>
          <button
            onClick={handleSignOut}
            className="text-white text-xl ml-4 md:ml-0 font-bold"
          >
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};
export default Header;
